requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.store("xSelectTextColumnWithIcon", {
      sectionId: '',
      currentVariant: null,
      estimatedDelivery: null,
      column: null, 
      blockId: '',
      finalMessage: '',
      selectColumn(column, element) {
        const template = element.dataset.estimatedDeliveryDate;
        const propertyName = element.dataset.propertyName;
        const isOpenDrawerAvailability = element.dataset.isPickupAvailability === "true";
        this.sectionId = element.dataset.sectionId;
        this.blockId = element.dataset.blockId;
        
        const newCurrentVariantInfoElement = document.querySelector(`#CurrentVariantInfo__${this.sectionId}`);
        if (newCurrentVariantInfoElement) {
          this.currentVariant = JSON.parse(newCurrentVariantInfoElement.textContent);
        }

        const estimateMessageElm = document.querySelector(`.estimate-shipping-message__${this.blockId}__${column} .estimate-shipping-message`);
        if (estimateMessageElm) {
          this.finalMessage = estimateMessageElm.innerHTML;
        }

        const inputField = document.getElementById('EstimateShippingInput');
        if (inputField && this.finalMessage && propertyName) {
          inputField.name = `properties[${propertyName}]`;
          inputField.value = this.stripHtml(this.finalMessage);
        }

        if (isOpenDrawerAvailability) {
          this.openDrawerAvailability();
        }
        
        if (this.finalMessage && template) {
          this.estimatedDelivery = this.finalMessage;
        } else {
          this.estimatedDelivery = null;
        }
        
        this.column = column;
      },

      stripHtml(html) {
        return html.replace(/<[^>]*>/g, '');
      },
      
      openDrawerAvailability() {
        const buttonOpenDrawer = document.getElementById(`OpenPickUp`);
        if (buttonOpenDrawer) {
          buttonOpenDrawer.click();
        }
      },
      
      updatePickUpAvailability(isFirstLoading = true) {
        const pickupAvailabilityEle = document.querySelector(`#PickupAvailability__${this.sectionId}`);
        if (!pickupAvailabilityEle) return;
        
        if (this.currentVariant && this.currentVariant.available) {
          fetch(`${window.Shopify.routes.root}variants/${this.currentVariant.id}/?section_id=pickup-availability`)
            .then(response => response.text())
            .then(text => {
              const pickupAvailabilityHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
              if (pickupAvailabilityHTML) {
                pickupAvailabilityEle.innerHTML = pickupAvailabilityHTML.innerHTML;
              }
            })
            .catch(e => {
              console.error(e);
            });
        } else {
          pickupAvailabilityEle.innerHTML = '';
        }
      },

      initFromElement(element) {
        if (element) {
          const columnIndex = element.dataset.columnIndex;
          this.selectColumn(columnIndex, element);
        }
      },
      
      initFirstVisibleColumn() {
        const allColumns = document.querySelectorAll('.shipping-options-item-wrapper[data-column-index]');
        
        if (allColumns.length === 0) return;
        
        for (let i = 0; i < allColumns.length; i++) {
          const column = allColumns[i];
          const style = window.getComputedStyle(column);
          
          if (style.display !== 'none' && style.visibility !== 'hidden' && column.offsetParent !== null) {
            this.initFromElement(column);
            break;
          }
        }
      }
    });
    
    const store = Alpine.store("xSelectTextColumnWithIcon");
    if (store) {
      store.initFirstVisibleColumn();
    }
  });
});
